import React, { Component } from 'react';
import { connect } from 'react-redux';
import Sidemenu from '../../components/sidemenu';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Pagination from '../../components/pagination';
import Confirmation from '../../components/confirmation';
import QuestionDetails from '../../components/questionDetails';
import Dropdown from '../../components/elements/dropdown01';
import * as Styled from './styled';

import search from '../../images/search.svg';
import editIcon from '../../images/edit.svg';
import deleteIcon from '../../images/delete.svg';
import publicIcon from '../../images/eye.svg';

import { questionRequest, filterRequest, deleteRequest, clearDeleteRequest } from './actions';
import { getRequest } from '../addAssessmentQuestion/actions';

class AssessmentQuestion extends Component {
  constructor (props) {
    super(props)
    this.state = {
      page: 1,
      entries: 10,
      confirmation: false,
      confirmationType: 'confirm',
      confirmationHeading: 'Would you like to delete this question?',
      details: false,
      difficulty: [
        { id: 'EASY', title: 'Easy' },
        { id: 'MEDIUM', title: 'Medium' },
        { id: 'HARD', title: 'Hard' },
      ],
      owners: [
        { id: 'COFFEEE', title: 'Coffeee' },
        { id: 'BOOTCAMP', title: 'Bootcamp' },
        { id: 'RECRUITER', title: 'Recruiter' },
        {id:'CAMPAIGN', title: 'campaign'},
        { id: 'COFFEEEPLUS', title: 'Coffeee Plus' },
        { id: 'CONTESTPLUS', title: 'Contest Plus' },
        { id: 'PRACTICE', title: 'Practice' },


      ],
      filters: {}
    }
  }

  UNSAFE_componentWillMount() {
    this.props.questionRequest();
    this.props.filterRequest();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps
    && nextProps.assessmentQuestion
    && nextProps.assessmentQuestion.delete
    && nextProps.assessmentQuestion.delete.meta
    && nextProps.assessmentQuestion.delete.meta.code === 403) {
      const confirmationHeading = [];
      confirmationHeading.push(<div>{nextProps.assessmentQuestion.delete.meta.message}</div>);
      if (nextProps.assessmentQuestion.delete.data
      && nextProps.assessmentQuestion.delete.data.test_list) {
        for (let i = 0; i < nextProps.assessmentQuestion.delete.data.test_list.length; i++) {
          if (nextProps.assessmentQuestion.delete.data.test_list[i]
          && nextProps.assessmentQuestion.delete.data.test_list[i].test_title) {
            confirmationHeading.push(
              <div style={{ fontSize: '22px', marginTop: '4px', textAlign: 'center' }}>{nextProps.assessmentQuestion.delete.data.test_list[i].test_title}</div>
            );
          }
        }
      }
      this.setState({ confirmationType: 'notify', confirmationHeading, confirmation: true }, () => this.props.clearDeleteRequest());
    }
  }

  paginationClick = (page) => {
    this.setState({ page })
  }

  filterSelect = (id, name) => {
    const filters = this.state.filters;
    if (typeof id !== 'undefined' && id !== null && id !== '') {
      filters[name] = id;
    } else {
      delete filters[name];
    }
    this.props.questionRequest(filters);
    this.setState({ filters });
  }

  deleteQuestion = (id) => {
    this.setState({ id, confirmationType: 'confirm', confirmationHeading: 'Would you like to delete this question?', confirmation: true });
  }

  closeConfirmation = () => {
    this.setState({ confirmation: false });
  }

  confirmDelete = () => {
    const id = this.state.id;
    this.props.deleteRequest(id, this.state.filters);
    this.setState({ confirmation: false, id: '' })
  }

  viewQuestion = (id) => {
    this.props.getRequest(id);
    this.setState({ details: true });
  }

  closeDetails = () => {
    this.setState({ details: false });
  }

  render () {
    const { page, entries, filters, difficulty, owners, confirmation, details, confirmationHeading, confirmationType } = this.state;
    const { questions, filter } = this.props.assessmentQuestion;
    const { getQuestion, getQuestionLoading } = this.props.addAssessmentQuestion;

    return (
      <Styled.MainDiv>
        <Confirmation show={confirmation} heading={confirmationHeading} type={confirmationType} close={this.closeConfirmation} confirm={this.confirmDelete} buttonText="Delete" />
        <QuestionDetails show={details} heading="Question Details" close={this.closeDetails} loading={getQuestionLoading} question={getQuestion} />
        <Sidemenu collapsed={this.state.sideMenuCollapsed} />
        <Styled.ColumnDiv>
          <Header />

          <Styled.ContentWrapDiv>
            <Styled.ContentDiv>
              <Styled.HeaderWrapDiv>
                <div>All Questions</div>
                <div style={{display: "flex", alignItems: "center", justifyContent: "space-betweeen"}}>
                  <Styled.AddLink to="/assessment-question/add"><span>+</span>Add Question</Styled.AddLink>
                  <Styled.AddLink to="/import-questions" style={{marginLeft: "20px"}}><span>+</span>Import Questions</Styled.AddLink>
                </div>
              </Styled.HeaderWrapDiv>

              <div style={{ minHeight: '58px' }}>
                { typeof filter !== 'undefined' ?
                  <Styled.FilterWrapDiv>
                    <Dropdown title="Skills" list={filter.category} value="id" name="master_skill_id" selected={this.filterSelect} width="115px" option="category_name" active={filters} addAll />
                    <Dropdown title="Topic" list={filter.topic} value="id" name="topic_id" selected={this.filterSelect} width="115px" option="topic_name" active={filters} addAll />
                    <Dropdown title="Difficulty" list={difficulty} value="id" name="difficulty_type" selected={this.filterSelect} width="115px" option="title" active={filters} addAll />
                    <Dropdown title="Type" list={filter.question_type} value="id" name="question_type_id" selected={this.filterSelect} width="115px" option="question_type_name" active={filters} addAll />
                    <Dropdown title="Owners" list={owners} value="id" name="owners" selected={this.filterSelect} width="115px" option="title" active={filters} addAll />
                    {/* <Styled.SearchDiv>
                      <img src={search} alt="search" />
                      <input type="text" placeholder="Search" />
                    </Styled.SearchDiv> */}
                  </Styled.FilterWrapDiv>
                : ''
                }
              </div>

              <Styled.CardDiv>
                <Styled.QuestionTable>
                  <thead>
                    <tr>
                      <th>Question Title </th>
                      <th>Skills</th>
                      <th>Difficulty</th>
                      <th>Topic</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    { questions && questions.length > 0 && questions.map((que, queIndex) => (
                      queIndex >= ((page - 1) * entries) && queIndex < (page * entries) ?
                        <tr>
                          <td>{que.title}</td>
                          <td>{que.category_name}</td>
                          <td>{que.difficulty_level}</td>
                          <td>{que.question_topic}</td>
                          <td>
                            <div>
                              <button onClick={() => this.viewQuestion(que.question_id)}>
                                <img src={publicIcon} alt="view" title="View Question" />
                              </button>
                              <Styled.UpdateLink to={`/assessment-question/edit/${que.question_id}`}>
                                <img src={editIcon} alt="edit" title="Edit Question" />
                              </Styled.UpdateLink>
                              <button onClick={() => this.deleteQuestion(que.question_id)}>
                                <img src={deleteIcon} alt="delete" title="Delete Question" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      : ''
                    )) }
                  </tbody>
                </Styled.QuestionTable>

                { questions && questions.length > 10 ?
                  <Pagination
                    count={questions.length}
                    entries={entries}
                    currentPage={page}
                    paginationClick={this.paginationClick}
                  />
                : <div />
                }
              </Styled.CardDiv>
            </Styled.ContentDiv>

            <Footer />
          </Styled.ContentWrapDiv>

        </Styled.ColumnDiv>
      </Styled.MainDiv>
    )
  }
}

const mapStateToProps = state => ({
  assessmentQuestion: state.assessmentQuestion,
  addAssessmentQuestion: state.addAssessmentQuestion,
})

const mapDispatchToProps = {
  questionRequest,
  filterRequest,
  deleteRequest,
  getRequest,
  clearDeleteRequest
}

export default connect(mapStateToProps, mapDispatchToProps)(AssessmentQuestion)
